export const tripGetters = fields => fields.map(field => (
  trip => trip.get(field)));

export const offerGetters = fields => fields.map(field => (
  ({ trip, offer }) => offer.get(field, trip.get(field))));
